<template>
    <div class="vue-megamenu__container" ref="container" v-on:mouseover="mouseover()">
        <div v-if="hasCategories" class="vue-megamenu__inner">
            <category
                v-for="(category, index) in categories"
                v-bind:category="category"
                v-bind:isActive="isActive"
                v-bind:index="index"
                v-bind:key="category.id + '-category'"
            ></category>
             <!-- @category-updated="setBottomPossition"  -->
            <div v-if="hasLinks " class="vue-megamenu__link-container">
                <a v-for="(link, index) in links" v-bind:key="index + '-link'" :href="link.url" class="vue-megamenu__link-container__link">
                    <picture>
                        <img :src="link.image.replace(/(.jpg|.png)/, '_ew90_eh60.webp')" width="90" height="60" loading="lazy"/>
                    </picture>
                    <span>{{ link.title }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import Category from './Category.vue'
import useStore from './../store'
import { ICategory, IBottomLink } from './../type'

const store = useStore(window.pinia)

export default defineComponent({
    props: {
        category: {
            type: Object as PropType<ICategory>,
            required: true,
        },
        links: {
            type: Array as PropType<IBottomLink[]>,
            default: () => [],
        },
        isActive: {
            type: Boolean as PropType<boolean>,
        },
    },
    computed: {
        hasLinks () {
            return this.links.length > 0
        },
        hasCategories () {
            return this.categories.length > 0
        },
        categories () {
            return this.category.category
        },
    },
    // mounted () {
    //     this.$nextTick(function () {
    //         const positionLeftAndRight = (window.outerWidth - this.$refs.container.offsetWidth) / 2 * -1; // (1920 - 1280) / 2 * -1 => left: -470px and right: -470px
    //         this.$refs.container.style.left = positionLeftAndRight + 'px';
    //         this.$refs.container.style.right = positionLeftAndRight + 'px';
    //     });
    // },
    methods: {
        mouseover () {
            // If screen more than 980px. Stop opening if mouse out of the menu.
            if (!window.matchMedia('(max-width: 980px)').matches) {
                store.stopOpening()
            }
        },
    },
    components: {
        Category,
    },
})
</script>
